import { faFolder } from "@fortawesome/free-regular-svg-icons";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { InfoBarContext } from "../../../../../common/info";
import { isTouch } from "../../../../../utils/screenUtil";
import RequestPreview from "../../preview/RequestPreview";
import SubmittedDocumentation from "../../preview/SubmittedDocumentation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import DecisionUpload from "../../previewDocuments/DecisionAcceptance/DecisionUpload";
import Tooltip from "../../../../../common/tooltip/Tooltip";

function Solved({ title, requests, activeJournalId, setActiveJournalId }) {
  const infoBar = useContext(InfoBarContext);
  const { t } = useTranslation();

  return (
    <>
      <div className="subtitle">{title}</div>

      {requests &&
        requests.map((request, index) => (
          <RequestPreview
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`solved${index}`}
            {...request}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            decisionRegistryNumber={true}
            renderRequestActions={() => (
              <Tooltip
                content={"Predana dokumentacija"}
                children={
                  <FontAwesomeIcon
                    className="is-clickable"
                    icon={faFolder}
                    onClick={() => {
                      setActiveJournalId(request.uid);
                      infoBar.toggle(t("requests.submittedDocumentation.title"), () => (
                        <SubmittedDocumentation
                          letters={request.letters}
                          attachments={request.attachments}
                          finances={request.finances}
                        />
                      ));
                    }}
                    size="2x"
                  />
                }
              ></Tooltip>
            )}
            renderGeneralActions={() => (
              <div className="is-pulled-right" style={{ width: 33, height: 33 }}>
                <CircularProgressbar
                  value={request.progress}
                  text={`${request.progress}%`}
                  styles={buildStyles({
                    // Text size
                    width: "100%",
                  })}
                />
              </div>
            )}
            renderDecisionActions={() => (
              <DecisionUpload
                requests={request}
                formDataAsJson={{ id: request.uid }}
                acceptDocumentTypes={["image/png", "application/pdf", "image/jpeg"]}
              />
            )}
          />
        ))}
    </>
  );
}

export default Solved;
